import { Component, OnInit } from '@angular/core';
import { BbTableService, BbTableSelectOption } from '../../../services/bb-table.service';
import { SapiService } from '../../../services/sapi.service';
import { OverlayService, ModalDefinition } from '../../../services/overlay.service';
import { BbFilterConfiguration } from '../../shared/bb-filters/bb-filters.component';
import { Playlist } from '../../../interfaces/playlist';
import { PublicationService } from '../../../services/publication.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { AbstractListComponent } from '../../shared/abstract-list.component';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocationService } from '../../../services/location.service';

@Component({
	selector: 'playlist-list',
	templateUrl: './playlist-list.component.html',
	styleUrls: ['./playlist-list.component.scss'],
	providers: [BbTableService]
})

export class PlaylistListComponent extends AbstractListComponent implements OnInit {
	filterConfig: BbFilterConfiguration;
	deleteRight = false;
	currentFilter = 'all';

	rootPermission: boolean;

	constructor(protected bbTableService: BbTableService,
		protected publicationService: PublicationService,
		protected sapiService: SapiService,
		protected router: Router,
		protected overlayService: OverlayService,
		protected translate: TranslateService,
		protected locationService: LocationService,
		protected authenticationService: AuthenticationService) {

		super(bbTableService);

		this.authenticationService.hasPermission('delete').subscribe(hasRight => this.deleteRight = hasRight);
		this.authenticationService.hasPermission('root').subscribe((hasRight: boolean) => this.rootPermission = hasRight);

		this.listConfiguration = {
			name: 'cliplist',
			basePath: '/library/playlist',
			activePath: '/library/playlists',
			entityTranslation: this.translate.instant('PLAYLIST').toLowerCase(),
			entitiesTranslation: this.translate.instant('PLAYLISTS').toLowerCase()
		};


		this.filterConfig = {
			search: true,
			filters: [],
			presets: [{
				label: this.translate.instant('ALL'),
				value: 'all',
				filterSet: [],
			},
			{
				label: this.translate.instant('PUBLISHED'),
				value: 'published',
				filterSet: [{
					filters: [{
						type: 'cliplist',
						field: 'status',
						operator: 'is',
						value: 'published'
					}]
				}],
			},
			{
				label: this.translate.instant('DRAFT'),
				value: 'draft',
				filterSet: [{
					filters: [{
						type: 'cliplist',
						field: 'status',
						operator: 'is',
						value: 'draft'
					}]
				}],
			},
			{
				label: this.translate.instant('REGULAR'),
				value: 'regular',
				filterSet: [{
					filters: [{
						type: 'cliplist',
						field: 'listtype',
						operator: 'is',
						value: 'static'
					}]
				}],
			},
			{
				label: this.translate.instant('SMART'),
				value: 'smart',
				filterSet: [{
					filters: [{
						type: 'cliplist',
						field: 'listtype',
						operator: 'is',
						value: 'dynamic'
					}]
				}],
			}]
		};
	}

	ngOnInit() {
		this.bbTableService
			.setSelect(BbTableSelectOption.none)
			.setLimit(15)
			.sort('createddate', 'desc')
			.linkToUrl();

		super.ngOnInit();
	}

	currentFilterChanged(filter: string) {
		switch (filter) {
			case 'static':
				this.currentFilter = 'regular';
				break;
			case 'dynamic':
				this.currentFilter = 'smart';
				break;
			default:
				super.currentFilterChanged(filter);
		}
	}

	redirectToPlaylist(playlist: Playlist) {
		this.router.navigate(['/library/playlist', playlist.id, (playlist.listtype === 'static' ? 'selection' : 'filters')]);
	}

	showPreview(playlist: Playlist) {

		const modal: ModalDefinition = {
			icon: 'list-ol',
			title: playlist.title,
			component: {
				name: 'embed-preview',
				inputs: {
					playlist
				}
			}
		};

		this.overlayService.createModal(modal);
	}

	showData(playlistId: number) {
		const url = this.locationService.server + '/sapi/cliplist/' + playlistId + '/?sesstoken=' + this.sapiService.getSessionToken();
		const anchor = document.createElement('A');
		anchor.setAttribute('href', url);
		anchor.setAttribute('target', '_blank');

		const evt = document.createEvent('MouseEvents');
		evt.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		anchor.dispatchEvent(evt);
	}
}
